import {setInitialState} from '../../../utils/reducerOperations';

export const Default=()=>({
    fetchOutliersDataApi:setInitialState(),
});